var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('registerController', ['$scope', '$window', function ($scope, $window) {
    $scope.submited = false;
    $scope.formRegister = {}

    $window.addEventListener("message", function (ev) {
        if (ev.data == "submit-abort") {
            $scope.submited = false;
        }
    }, false);

    $scope.setRegisterForm = function (form) {
        $scope.formRegister = form;
    }

    $scope.submit = function (event) {
        $scope.formRegister.$setSubmitted();
        if ($scope.submited || !$scope.formRegister.$valid) {
            event.preventDefault();
            return;
        }
        // prevento two submission in form
        $scope.submited = true;
    };

    $scope.init = function (formData) {

        $scope.taxpayer_id = formData.taxpayer_id;
        $scope.first_name = formData.first_name;
        $scope.last_name = formData.last_name;
        $scope.user_name = formData.user_name;
        $scope.email = formData.email;
        $scope.birth_date = formData.birth_date;
        $scope.password = formData.password;
        $scope.password2 = formData.password2 || formData.password;
        $scope.email_enable = formData.email_enable;
        if (formData.errors && formData.errors.length > 0) {
            if (_.some(formData.errors, function (i) { return i.code != null && i.code.indexOf("password") != -1 })) {
                $scope.password = "";
                $scope.password2 = "";
            }
            if (formData.email_enable != null && formData.email_enable && _.some(formData.errors, function (i) { return i.code != null && (i.code.indexOf("user_name") != -1 || i.code.indexOf("email") != -1 )})) {
                $scope.email = "";
            }
        }
    };
}]);
